module.exports = __webpack_public_path__ + "img/true.e66eff2d.svg";